import React from "react";
import { Link } from "react-router-dom";
import "./styles/LegalPage.css";

function SSOConsentNote() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <span className="legal-header-brand">Excavate Research and Analysis Pvt Ltd</span>
        <Link to="/" className="legal-back-link">&#8592; Back to Login</Link>
      </header>

      <div className="legal-body">
        <h1 className="legal-doc-title">Notice for Users Accepting Microsoft SSO Invitations</h1>
        <p className="legal-doc-meta">Effective: 17 May 2026</p>

        <p className="legal-intro">
          This note explains what you are agreeing to when you accept the Microsoft permissions screen to
          access Excavate's applications and shared resources through Microsoft Entra (Azure AD) Single
          Sign-On under our tenant <strong>excavateanalysis.onmicrosoft.com</strong>.
        </p>

        <div className="legal-section">
          <h2>What permissions are being requested</h2>
          <p>
            The consent screen you see is generated by Microsoft and is the same screen Microsoft shows for
            any organisation that invites external users. It lists three items:
          </p>
          <div className="sso-permission-item">
            <strong>Receive your profile data</strong> — your name, work email address, and profile photo.
            We use this to identify you within our tenant.
          </div>
          <div className="sso-permission-item">
            <strong>Collect and log your activity</strong> — standard Microsoft audit logging of when you
            sign in, what resources you access within our tenant, and basic technical metadata. This is
            generated by Microsoft for security and compliance and is limited to activity within our tenant.
          </div>
          <div className="sso-permission-item">
            <strong>Use your profile data and activity data</strong> — permits us to administer your guest
            account in our tenant (for example, to grant and revoke access to specific resources).
          </div>
        </div>

        <div className="legal-section">
          <h2>What this does NOT include</h2>
          <ul className="sso-not-included">
            <li>We do not receive your password or any credentials from your home organisation.</li>
            <li>We cannot read your mailbox, calendar, OneDrive, Teams chats, or any other content in your home tenant.</li>
            <li>We cannot see your activity outside of our tenant.</li>
            <li>We do not sell or share your profile data with third parties for marketing.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Your control</h2>
          <p>
            You can review or revoke your consent for our organisation at any time by visiting{" "}
            <a href="https://myaccount.microsoft.com/organizations" target="_blank" rel="noreferrer">
              https://myaccount.microsoft.com/organizations
            </a>{" "}
            and selecting our tenant. Revoking access will end your ability to use the Services through SSO.
          </p>
        </div>

        <div className="legal-section">
          <h2>More information</h2>
          <p>
            Our full <Link to="/privacy">Privacy Policy</Link> and <Link to="/terms">Terms of Use</Link>{" "}
            are available on this site. For questions, contact{" "}
            <a href="mailto:privacy@excavateservices.com">privacy@excavateservices.com</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SSOConsentNote;
